module.exports = __webpack_public_path__ + "img/arrow_down.bcd39816.png";